import { FC } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Product } from '@setvi/shared/interfaces';
import { SText } from '@setvi/shared/components';
import { Box, IconButton } from '@material-ui/core';
import { ProductValue } from './components';

interface EnhancerDialogHeaderProps {
  product: Product;
  onCloseClick: () => void;
}

export const EnhancerDialogHeader: FC<EnhancerDialogHeaderProps> = ({
  product,
  onCloseClick
}) => (
  <Box display="flex" flexDirection="column" gridGap="8px">
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center">
      <SText
        maxLines={2}
        weight="bold"
        lineHeight="28px"
        size="xl"
        title={product.name}
      />

      <IconButton
        aria-label="close"
        size="small"
        style={{ height: 'fit-content' }}
        onClick={onCloseClick}>
        <CloseIcon style={{ width: 27, height: 27 }} />
      </IconButton>
    </Box>

    <Box display="flex">
      <ProductValue title="SKU:" value={product.manufacturerSku ?? '-'} />
      <ProductValue bullet title="MFG:" value={product.vendor?.name ?? '-'} />
    </Box>
  </Box>
);
